import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router';

import { toast } from 'react-toastify';
import API from '../../Utils/api';
import '../AuthShared.css';

export default function RecoverPasswordPage() {
    const { resetPasswordId } = useParams();

    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm({ mode: 'onBlur' });

    const password = watch('password');

    const onSubmit = async ({ password }) => {
        try {
            await API.recoverPassword({ recoverPasswordId: resetPasswordId, password });
            toast.success('Password was successfully updated!', {
                position: 'bottom-center'
            });
            navigate('/login');
        } catch {
            toast.error(`Couldn't reset password!`, {
                position: 'bottom-center'
            });
        }
    };

    return (
        <div className='auth'>
            <div className='auth-card'>
                <div className='auth-head'>
                    <h1>Set a new password</h1>
                    <p>Choose a new password for your account.</p>
                </div>

                {/* Two fixes here. The submit button used to sit outside the form,
                    and the password comparison ran after the API call had already
                    succeeded, so a mismatch still reset the password. */}
                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                    <div className='auth-field'>
                        <label htmlFor='recover-password'>New password</label>
                        <input
                            id='recover-password'
                            type='password'
                            autoComplete='new-password'
                            aria-invalid={errors.password ? 'true' : undefined}
                            {...register('password', {
                                required: 'Choose a password.',
                                minLength: {
                                    value: 8,
                                    message: 'Use at least 8 characters.'
                                }
                            })}
                        />
                        {errors.password && (
                            <p className='auth-error' role='alert'>
                                {errors.password.message}
                            </p>
                        )}
                    </div>

                    <div className='auth-field'>
                        <label htmlFor='recover-verify'>Confirm new password</label>
                        <input
                            id='recover-verify'
                            type='password'
                            autoComplete='new-password'
                            aria-invalid={errors.verifyPassword ? 'true' : undefined}
                            {...register('verifyPassword', {
                                required: 'Confirm your password.',
                                validate: value =>
                                    value === password || 'The passwords do not match.'
                            })}
                        />
                        {errors.verifyPassword && (
                            <p className='auth-error' role='alert'>
                                {errors.verifyPassword.message}
                            </p>
                        )}
                    </div>

                    <button type='submit' className='auth-submit'>
                        Reset password
                    </button>
                </form>

                <p className='auth-swap'>
                    Changed your mind?{' '}
                    <button
                        type='button'
                        className='auth-link'
                        onClick={() => navigate('/login')}
                    >
                        Back to log in
                    </button>
                </p>
            </div>
        </div>
    );
}
